import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { useCallback, useEffect, useState } from '@redneckz/uni-jsx/lib/hooks';
import { renderBlocksList } from '../../BlockRenderer/renderBlockList.js';
import { useRouter } from '../../hooks/useRouter.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { getUrlParams } from '../../utils/getUrlParams.js';
import { style } from '../../utils/style.js';
import { renderTabsLayout } from './renderTabsLayout.js';
export const TabsLayout = UniBlock(
// eslint-disable-next-line max-lines-per-function
({ className = '', tabs = [], block, tabsType, showCounter = false, isSticky = false, ...rest }) => {
    const id = getId(block ?? {});
    const router = useRouter();
    const isEveryLink = tabs.every((_) => _?.type === 'link');
    const tabsCounted = showCounter
        ? tabs.map((_) => ({
            ..._,
            count: _?.type === 'group' ? block?.slots?.[_?.tabName ?? '']?.length ?? 0 : 0,
        }))
        : tabs;
    const { isReady } = router;
    const [activeTabIndex, setActiveTabIndex] = useState(getInitSelectedIndex(tabsCounted, getUrlParams(id)));
    const activeItem = tabsCounted[activeTabIndex];
    const defaultSelectedTab = tabsCounted.findIndex((_) => Boolean(_.selected));
    //TODO: Вынести в отдельный хук
    useEffect(() => {
        const defaultTabIndex = router.query[id]
            ? tabsCounted.findIndex((_, i) => _.type === 'group' && (_?.tabName ?? String(i)) === router.query[id])
            : defaultSelectedTab;
        setActiveTabIndex(defaultTabIndex === -1 ? 0 : defaultTabIndex);
    }, [isReady, defaultSelectedTab, id]);
    const slotName = getSlotName(tabsCounted[activeTabIndex], activeTabIndex);
    const updateUrlSearchTabParam = (_, i) => {
        const searchParams = new URLSearchParams(router.query);
        if (_.text) {
            searchParams.set(id, _?.tabName ?? String(i));
        }
        else {
            searchParams.delete(id);
        }
        router.replace(`${router.pathname}?${searchParams}`, '', { scroll: false });
    };
    const handleChange = useCallback((_) => {
        const index = tabsCounted.indexOf(_);
        const tab = tabsCounted[index];
        setActiveTabIndex(index);
        if (tab.type === 'group') {
            updateUrlSearchTabParam(_, index);
        }
    }, [tabsCounted]);
    return (_jsxs(BlockWrapper, { className: style({ 'sticky top-1 z-20': isSticky && isEveryLink }, className), defaultPadding: "p-0", block: block, ...rest, children: [renderTabsLayout({
                className: style({
                    'pb-1': block?.slots && tabsType === 'default',
                    'sticky top-1 z-20': isSticky && !isEveryLink,
                }),
                items: getItems(tabs, tabsCounted),
                activeItem,
                tabsType,
                onChange: handleChange,
            }), _jsx("div", { className: "space-y-px @5xl:space-y-0 @5xl:grid @5xl:grid-cols-12 @5xl:gap-2xs", children: Object.entries(block?.slots ?? {}).map(([key, value]) => renderBlocksList(value, {
                    ...rest?.options,
                    slotName,
                    parent: block,
                    extraProps: { className: key === slotName ? '' : 'hidden' },
                })) })] }));
}, {
    slots: ({ tabs }) => tabs?.map(getSlotName)?.filter(Boolean) || [],
});
const getId = ({ __id, anchor }) => anchor ?? __id ?? 'tabs';
const getItems = (tabs, tabsCounted) => (tabsCounted?.length ? tabsCounted : tabs);
const getSlotName = (tab, index) => tab?.type === 'group' ? tab?.tabName || `Слот №${index + 1}` : '';
const getInitSelectedIndex = (tabs, paramsId) => paramsId
    ? Number(paramsId)
    : tabs.reduce((selectedIndex, tab, i) => (tab.selected ? i : selectedIndex), 0);
//# sourceMappingURL=TabsLayout.js.map